/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon20Light = forwardRef('ArrowDim1DiagRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.5 2a.5.5 0 0 0 0 1h4.793L3 16.293V11.5a.5.5 0 0 0-1 0v5A1.5 1.5 0 0 0 3.5 18h5a.5.5 0 0 0 0-1H3.707L17 3.707V8.5a.5.5 0 0 0 1 0v-5A1.5 1.5 0 0 0 16.5 2h-5Z" })));
});
